import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export enum AppEventType {
    DataFetchingStarted = 'DATA_FETCHING_STARTED',
    DataFetchingCompleted = 'DATA_FETCHING_COMPLETED',
};

export class AppEvent<T> {
    constructor(
        public type: AppEventType,
        public payload?: T,
    ) { };
};

@Injectable({
    providedIn: 'root'
})
export class BroadcastService {
    private eventBrocker = new Subject<AppEvent<any>>();

    on(eventType: AppEventType): Observable<AppEvent<any>> {
        return this.eventBrocker.pipe(filter(event => event.type === eventType));
    };

    dispatch<T>(event: AppEvent<T>): void {
        this.eventBrocker.next(event);
    };
};
